/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-bitwise */
import React, {
  useState, useEffect, useContext, useMemo, useCallback, useRef,
} from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import {
  Search, ChevronsUpDown, ChevronUp, ChevronDown, ChevronLeft, ChevronRight,
} from 'lucide-react';
import RowActionMenu from '../../components/RowActionMenu';
import { sendRequest } from '../../api/shootAPI';
import API from '../../api/endpoints';
import { Navbar, Sidebar } from '../../components';
import { UserContext } from '../../contexts/User';
import useDebounce from '../../hooks/useDebounce';
import EmptyIcon from '../../images/emptyRequests.svg';
import ViewRequestModal from './ViewRequestModal';
import ApproveRequestModal from './ApproveRequestModal';
import DenyRequestModal from './DenyRequestModal';
import RequestModal from './RequestModal';

const TAB_KEYS = ['Submitted', 'Approved', 'Denied', 'All'];
const PAGE_SIZE = 10;
const buildInitialPages = () => TAB_KEYS.reduce((acc, key) => ({ ...acc, [key]: 1 }), {});
const buildInitialPagination = () => TAB_KEYS.reduce((acc, key) => ({
  ...acc, [key]: { totalPages: 0, totalCounts: 0 },
}), {});

function StatusPill({ status }) {
  if (status === 'Submitted') {
    return (
      <span
        className="inline-flex items-center px-2.5 py-0.5 rounded-full"
        style={{ backgroundColor: '#fde6d2', color: '#F19235', fontSize: '11px', fontWeight: 600 }}
      >
        Submitted
      </span>
    );
  }
  if (status === 'Approved') {
    return (
      <span
        className="inline-flex items-center px-2.5 py-0.5 rounded-full"
        style={{ backgroundColor: '#eef5ea', color: '#53A551', fontSize: '11px', fontWeight: 600 }}
      >
        Approved
      </span>
    );
  }
  return (
    <span
      className="inline-flex items-center px-2.5 py-0.5 rounded-full"
      style={{ backgroundColor: '#fdebe6', color: '#b94f3c', fontSize: '11px', fontWeight: 600 }}
    >
      Denied
    </span>
  );
}

function ReasonCell({ reason }) {
  if (!reason) {
    return <span className="text-ink-500">—</span>;
  }
  // Plain text, clamped to 2 lines; the full reason shows in a native tooltip on hover.
  return (
    <span
      title={reason}
      className="text-ink-900 break-words"
      style={{
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
      }}
    >
      {reason}
    </span>
  );
}

function SortIcon({ active, dir }) {
  if (!active) return <ChevronsUpDown size={12} className="text-ink-500" />;
  return dir === 'asc' ? <ChevronUp size={12} /> : <ChevronDown size={12} />;
}

function RowActions({ status, onView, onApprove, onDeny }) {
  // Shared design-system menu (same as Insider Threats / Team Engagement):
  // consistent hover, red destructive item, and a portaled panel that can't be
  // clipped by the table's horizontal scroll.
  return (
    <RowActionMenu
      orientation="vertical"
      iconSize={16}
      ariaLabel="Open actions"
      triggerClassName="inline-flex items-center justify-center p-1 rounded hover:bg-surface-1 text-ink-500 transition bg-transparent border-0 align-middle"
      items={[
        { label: 'View Request', onClick: onView },
        { label: 'Approve', onClick: onApprove, disabled: status === 'Approved' },
        { label: 'Deny Request', onClick: onDeny, disabled: status === 'Denied', destructive: true },
      ]}
    />
  );
}

function InlinePagination({
  page, pageSize, total, onPageChange,
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(total, page * pageSize);
  const pages = useMemo(() => {
    const max = 5;
    if (totalPages <= max) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const half = Math.floor(max / 2);
    let from = Math.max(1, page - half);
    let to = from + max - 1;
    if (to > totalPages) { to = totalPages; from = totalPages - max + 1; }
    return Array.from({ length: max }, (_, i) => from + i);
  }, [page, totalPages]);

  return (
    <div
      className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-5 py-3"
      style={{ borderTop: '1px solid #f1f2f5' }}
    >
      <div className="flex items-center gap-1 flex-wrap">
        <button
          type="button"
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page === 1}
          aria-label="Previous page"
          className="w-8 h-8 inline-flex items-center justify-center rounded-[6px] text-ink-900 hover:bg-surface-1 disabled:opacity-40 disabled:cursor-not-allowed transition"
        >
          <ChevronLeft size={16} />
        </button>
        {pages.map((p) => {
          const active = p === page;
          return (
            <button
              key={p}
              type="button"
              onClick={() => onPageChange(p)}
              className="min-w-[32px] h-8 px-2 inline-flex items-center justify-center rounded-[6px] transition"
              style={{
                fontSize: '14px',
                fontWeight: 500,
                backgroundColor: active ? '#213d69' : 'transparent',
                color: active ? '#ffffff' : '#0e1e40',
              }}
            >
              {p}
            </button>
          );
        })}
        <button
          type="button"
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={page === totalPages || total === 0}
          aria-label="Next page"
          className="w-8 h-8 inline-flex items-center justify-center rounded-[6px] text-ink-900 hover:bg-surface-1 disabled:opacity-40 disabled:cursor-not-allowed transition"
        >
          <ChevronRight size={16} />
        </button>
      </div>
      <div className="flex items-center gap-3 text-ink-900 tabular-nums flex-wrap" style={{ fontSize: '14px' }}>
        <span>
          {start}
          -
          {end}
          {' '}
          of
          {' '}
          {total}
        </span>
      </div>
    </div>
  );
}

const dateOptions = {
  weekday: 'short',
  month: 'short',
  day: '2-digit',
  year: 'numeric',
};

function formatDate(d) {
  return new Date(d).toLocaleDateString('en-US', dateOptions);
}

function formatHHMM(totalMinutes) {
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  const hh = h < 10 ? `0${h}` : `${h}`;
  const mm = m < 10 ? `0${m}` : `${m}`;
  return `${hh}:${mm}`;
}

function MembersPto() {
  const { member } = useContext(UserContext);
  const [requests, setRequests] = useState([]);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showDenyModal, setShowDenyModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState();
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [teamMembers, setTeamMembers] = useState([]);
  const [loadingMembers, setLoadingMembers] = useState(false);
  const [hasLoadedTeamMembers, setHasLoadedTeamMembers] = useState(false);
  const [loadingRequests, setLoadingRequests] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [pageByStatus, setPageByStatus] = useState(buildInitialPages);
  const [paginationByStatus, setPaginationByStatus] = useState(buildInitialPagination);
  const [statusCounts, setStatusCounts] = useState({
    Submitted: 0, Approved: 0, Denied: 0, All: 0,
  });
  const [scope, setScope] = useState('direct');
  const [canViewAll, setCanViewAll] = useState(false);
  // 'workspace' for admins, 'teams' for team leaders — see below, it only changes
  // the tooltip; the server decides what "All Members" actually returns.
  const [allScope, setAllScope] = useState('workspace');
  const [searchTerm, setSearchTerm] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [sortKey, setSortKey] = useState('requestedOn');
  const [sortDir, setSortDir] = useState('desc');
  const teamMembersLoadRef = useRef(null);
  const { debounce } = useDebounce();

  const currentStatus = TAB_KEYS[activeTab];

  const getTeamMembers = async () => {
    setLoadingMembers(true);
    try {
      const response = await sendRequest({
        method: 'get', url: API.WORKSPACE.members(member.workspaceId),
      });
      if (response.data) {
        const directReports = response.data.members.filter(
          (m) => m.reportingManager === member.id,
        );
        setTeamMembers([...directReports].filter(Boolean));
      }
      setHasLoadedTeamMembers(true);
    } finally {
      setLoadingMembers(false);
    }
  };

  const ensureTeamMembersLoaded = useCallback(async () => {
    if (hasLoadedTeamMembers) return;
    if (!teamMembersLoadRef.current) {
      teamMembersLoadRef.current = getTeamMembers().finally(() => {
        teamMembersLoadRef.current = null;
      });
    }
    await teamMembersLoadRef.current;
  }, [hasLoadedTeamMembers]);

  const handlePrefetchTeamMembers = useCallback(() => {
    if (!hasLoadedTeamMembers && !loadingMembers) {
      ensureTeamMembersLoaded().catch(() => {});
    }
  }, [ensureTeamMembersLoaded, hasLoadedTeamMembers, loadingMembers]);

  const handleOpenRequestModal = useCallback(async () => {
    await ensureTeamMembersLoaded().catch(() => {});
    setShowRequestModal(true);
  }, [ensureTeamMembersLoaded]);

  const fetchRequests = useCallback(async (statusKey, page, requestedScope = scope, requestedSearch = searchTerm) => {
    const safePage = Math.max(page || 1, 1);
    setLoadingRequests(true);
    try {
      const response = await sendRequest({
        method: 'get',
        url: API.WORKSPACE.getTeamOffTimeData(member.workspaceId, member.id),
        params: {
          page: safePage,
          pageSize: PAGE_SIZE,
          includeStatusCounts: false,
          scope: requestedScope,
          search: requestedSearch || undefined,
          ...(statusKey !== 'All' ? { status: statusKey } : {}),
        },
      });

      if (response.success && response.data) {
        setRequests(response.data.offTimeRequests || []);
        setCanViewAll(!!response.data.canViewAll);
        setAllScope(response.data.allScope || 'workspace');
        const filteredCounts = typeof response.data.filteredCounts === 'number' ? response.data.filteredCounts : 0;
        setStatusCounts((prev) => ({ ...prev, [statusKey]: filteredCounts }));
        const totalPages = typeof response.data.totalPages === 'number'
          ? response.data.totalPages
          : (filteredCounts ? Math.ceil(filteredCounts / PAGE_SIZE) : 0);
        const resolvedPage = response.data.currentPage || Math.min(safePage, Math.max(totalPages, 1));
        setPaginationByStatus((prev) => ({
          ...prev,
          [statusKey]: { totalPages, totalCounts: filteredCounts },
        }));
        setPageByStatus((prev) => ({ ...prev, [statusKey]: resolvedPage }));
      } else {
        setRequests([]);
        setStatusCounts({ Submitted: 0, Approved: 0, Denied: 0, All: 0 });
        setCanViewAll(false);
        setAllScope('workspace');
        setPaginationByStatus(buildInitialPagination());
        setPageByStatus(buildInitialPages());
      }
    } finally {
      setLoadingRequests(false);
    }
  }, [member.id, member.workspaceId, scope, searchTerm]);

  const refreshCurrentTab = useCallback(() => {
    fetchRequests(currentStatus, pageByStatus[currentStatus] || 1, scope, searchTerm);
  }, [currentStatus, fetchRequests, pageByStatus, scope, searchTerm]);

  useEffect(() => {
    fetchRequests(TAB_KEYS[0], 1, scope, searchTerm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setHasLoadedTeamMembers(false);
    setTeamMembers([]);
    teamMembersLoadRef.current = null;
  }, [member.id, member.workspaceId]);

  const handleTabChange = (newTab) => {
    setActiveTab(newTab);
    const tabKey = TAB_KEYS[newTab];
    const nextPage = pageByStatus[tabKey] || 1;
    setRequests([]);
    fetchRequests(tabKey, nextPage, scope, searchTerm);
  };

  const handleScopeChange = (value) => {
    setScope(value);
    setPageByStatus(buildInitialPages());
    setPaginationByStatus(buildInitialPagination());
    setStatusCounts({ Submitted: 0, Approved: 0, Denied: 0, All: 0 });
    setRequests([]);
    fetchRequests(currentStatus, 1, value, searchTerm);
  };

  const handlePageChange = useCallback((tabKey, page) => {
    setPageByStatus((prev) => ({ ...prev, [tabKey]: page }));
    fetchRequests(tabKey, page, scope, searchTerm);
  }, [fetchRequests, scope, searchTerm]);

  const debouncedSearchFetch = useMemo(
    () => debounce((value) => {
      setSearchTerm(value);
      setPageByStatus(buildInitialPages());
      setPaginationByStatus(buildInitialPagination());
      fetchRequests(currentStatus, 1, scope, value);
    }, 300),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debounce, fetchRequests, currentStatus, scope],
  );

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
    debouncedSearchFetch(e.target.value.trim());
  };

  const toggleSort = (key) => {
    if (key === sortKey) setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
    else {
      setSortKey(key);
      setSortDir('asc');
    }
  };

  const TABS = [
    { id: 0, label: 'Submitted', countKey: 'Submitted' },
    { id: 1, label: 'Approved', countKey: 'Approved' },
    { id: 2, label: 'Denied', countKey: 'Denied' },
    { id: 3, label: 'All', countKey: 'All' },
  ];

  const extraColumn = useMemo(() => {
    if (currentStatus === 'Approved') return { label: 'Approved By', get: (r) => r.manager?.user?.fullName ?? '—' };
    if (currentStatus === 'Denied') return { label: 'Denied By', get: (r) => r.manager?.user?.fullName ?? '—' };
    if (currentStatus === 'All') {
      return {
        label: 'Approved / Denied By',
        get: (r) => r.manager?.user?.fullName ?? '—',
      };
    }
    return null;
  }, [currentStatus]);

  const currentTotal = paginationByStatus[currentStatus]?.totalCounts || 0;
  const currentPage = pageByStatus[currentStatus] || 1;

  const sortHeader = (label, key) => (
    <button
      type="button"
      onClick={() => toggleSort(key)}
      className={`inline-flex items-center gap-1 uppercase tracking-wider transition text-left ${sortKey === key ? 'text-ink-900' : 'hover:text-ink-900'}`}
      style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.05em', lineHeight: '16px' }}
    >
      <span>{label}</span>
      <span className="flex-shrink-0 inline-flex items-center">
        <SortIcon active={sortKey === key} dir={sortDir} />
      </span>
    </button>
  );

  return (
    <>
      <Navbar />
      <Sidebar />
      <div className="screen-wrapper">
        <div className="screen-header" style={{ fontFamily: 'Inter, sans-serif' }}>
          <div className="flex flex-col gap-3 mb-4 sm:flex-row sm:items-start sm:justify-between">
            <div className="min-w-0 flex-1">
              <h1
                className="font-bold text-ink-900 leading-tight truncate text-2xl lg:text-[32px] lg:leading-10"
                data-testid="title"
                data-tour="team-pto"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                Team Member&apos;s Time Off
              </h1>
            </div>
          </div>

          <div
            className="rounded-xl bg-white shadow-[0_1px_2px_rgba(14,30,64,0.04)] overflow-hidden"
            style={{ border: '1px solid #e8eaf0' }}
          >
            {/* Top bar: tabs + search + scope + request button */}
            <div
              className="flex flex-col xl:flex-row xl:items-center gap-3 px-5 pt-4 pb-3"
              style={{ borderBottom: '1px solid #f1f2f5' }}
            >
              <div className="flex items-center gap-6 -mb-3 xl:mb-0 overflow-x-auto">
                {TABS.map((t) => {
                  const active = activeTab === t.id;
                  return (
                    <button
                      key={t.id}
                      type="button"
                      onClick={() => handleTabChange(t.id)}
                      className="relative pb-3 xl:pb-0 transition whitespace-nowrap"
                      style={{
                        fontSize: '14px',
                        fontWeight: 500,
                        color: active ? '#0e1e40' : '#546077',
                      }}
                    >
                      {t.label}
                      {' '}
                      <span className="text-ink-500">
                        (
                        {statusCounts[t.countKey] || 0}
                        )
                      </span>
                      {active && (
                        <span
                          className="xl:hidden absolute left-0 right-0 rounded-full"
                          style={{ bottom: '-1px', height: '2px', backgroundColor: '#213d69' }}
                        />
                      )}
                    </button>
                  );
                })}
              </div>
              <div className="flex-1 xl:flex xl:justify-end flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <div className="relative w-full sm:w-64" style={{ height: '40px' }}>
                  <Search
                    size={14}
                    className="text-ink-500 pointer-events-none"
                    style={{
                      position: 'absolute',
                      left: '12px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      zIndex: 1,
                    }}
                  />
                  <input
                    type="text"
                    value={searchInput}
                    onChange={handleSearchInputChange}
                    placeholder="Search Team Members"
                    className="w-full rounded-[8px] bg-white text-ink-900 placeholder:text-ink-500 focus:outline-none"
                    style={{
                      height: '40px',
                      paddingLeft: '36px',
                      paddingRight: '12px',
                      fontSize: '14px',
                      lineHeight: '20px',
                      border: '1px solid #e0e1e6',
                      boxSizing: 'border-box',
                    }}
                  />
                </div>
                <div
                  className="inline-flex p-1 rounded-[10px] bg-white"
                  style={{ border: '1px solid #e0e1e6' }}
                >
                  {[
                    { id: 'direct', label: 'Direct Reports' },
                    { id: 'all', label: 'All Members' },
                  ].map((opt) => {
                    const active = scope === opt.id;
                    const disabled = opt.id === 'all' && !canViewAll;
                    const title = opt.id === 'all' && allScope === 'teams'
                      ? 'Members of the teams you lead'
                      : undefined;
                    return (
                      <button
                        key={opt.id}
                        type="button"
                        title={title}
                        disabled={disabled}
                        onClick={() => handleScopeChange(opt.id)}
                        className="rounded-[8px] transition whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
                        style={{
                          padding: '6px 12px',
                          fontSize: '14px',
                          fontWeight: 500,
                          backgroundColor: active ? '#0e1e40' : 'transparent',
                          color: active ? '#ffffff' : '#0e1e40',
                        }}
                      >
                        {opt.label}
                      </button>
                    );
                  })}
                </div>
                <button
                  type="button"
                  onClick={handleOpenRequestModal}
                  onMouseEnter={handlePrefetchTeamMembers}
                  onFocus={handlePrefetchTeamMembers}
                  disabled={loadingMembers}
                  className="inline-flex items-center h-10 px-4 rounded-[8px] bg-[#53A551] text-white hover:bg-[#458a44] transition disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                  style={{ fontSize: '14px', fontWeight: 600 }}
                >
                  Request PTO
                </button>
              </div>
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full table-fixed" style={{ minWidth: extraColumn ? '1100px' : '1000px' }}>
                <thead style={{ borderBottom: '1px solid #f1f2f5' }}>
                  <tr className="text-left bg-surface-page align-top">
                    <th style={{ padding: '12px 8px 12px 16px', width: '13%' }}>
                      {sortHeader('Member', 'member')}
                    </th>
                    <th style={{ padding: '12px 8px', width: '14%' }}>
                      {sortHeader('Policy Name', 'policy')}
                    </th>
                    <th style={{ padding: '12px 8px', width: '16%' }}>
                      <span
                        className="uppercase tracking-wider"
                        style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.05em', color: '#546077' }}
                      >
                        Reason
                      </span>
                    </th>
                    <th style={{ padding: '12px 8px', width: '13%' }}>
                      {sortHeader('Start', 'start')}
                    </th>
                    <th style={{ padding: '12px 8px', width: '13%' }}>
                      {sortHeader('End', 'end')}
                    </th>
                    <th style={{ padding: '12px 8px', width: '9%' }}>
                      {sortHeader('Hours', 'hours')}
                    </th>
                    <th style={{ padding: '12px 8px', width: '8%' }}>
                      {sortHeader('Status', 'status')}
                    </th>
                    <th style={{ padding: '12px 8px', width: '13%' }}>
                      {sortHeader('Requested on', 'requestedOn')}
                    </th>
                    {extraColumn && (
                      <th style={{ padding: '12px 8px', width: '12%' }}>
                        <span
                          className="uppercase tracking-wider"
                          style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.05em', color: '#546077' }}
                        >
                          {extraColumn.label}
                        </span>
                      </th>
                    )}
                    <th style={{ padding: '12px 8px', width: '64px' }} />
                  </tr>
                </thead>
                <tbody>
                  {loadingRequests && (
                    <tr>
                      <td colSpan={extraColumn ? 10 : 9} style={{ padding: '48px 20px' }}>
                        <div className="flex items-center justify-center">
                          <CircularProgress size={24} sx={{ color: 'inherit' }} />
                        </div>
                      </td>
                    </tr>
                  )}
                  {!loadingRequests && requests.length === 0 && (
                    <tr>
                      <td colSpan={extraColumn ? 10 : 9} style={{ padding: '40px 20px' }}>
                        <div className="flex flex-col items-center gap-3">
                          <img src={EmptyIcon} alt="" width={48} height={48} />
                          <span className="text-sm text-ink-500">No requests found.</span>
                        </div>
                      </td>
                    </tr>
                  )}
                  {!loadingRequests && requests.map((r) => (
                    <tr
                      key={r.id}
                      className="hover:bg-surface-page transition align-top"
                      style={{ borderTop: '1px solid #f1f2f5', fontSize: '14px' }}
                    >
                      <td style={{ padding: '12px 8px 12px 16px' }}>
                        <span className="text-ink-900 break-words" style={{ fontWeight: 500 }}>
                          {r.member?.user?.firstName}
                          {' '}
                          {r.member?.user?.lastName}
                        </span>
                      </td>
                      <td className="text-ink-900 break-words" style={{ padding: '12px 8px' }}>
                        {r.offTimePolicy?.name}
                      </td>
                      <td style={{ padding: '12px 8px' }}>
                        <ReasonCell reason={r.reason} />
                      </td>
                      <td className="text-ink-900 tabular-nums" style={{ padding: '12px 8px' }}>
                        {formatDate(r.startDate)}
                      </td>
                      <td className="text-ink-900 tabular-nums" style={{ padding: '12px 8px' }}>
                        {formatDate(r.endDate)}
                      </td>
                      <td className="text-ink-900 tabular-nums" style={{ padding: '12px 8px' }}>
                        {formatHHMM(r.totalHours || 0)}
                      </td>
                      <td style={{ padding: '12px 8px' }}>
                        <StatusPill status={r.status} />
                      </td>
                      <td className="text-ink-900 tabular-nums" style={{ padding: '12px 8px' }}>
                        {formatDate(r.createdAt)}
                      </td>
                      {extraColumn && (
                        <td className="text-ink-900 break-words" style={{ padding: '12px 8px' }}>
                          {extraColumn.get(r)}
                        </td>
                      )}
                      <td style={{ padding: '12px 8px', verticalAlign: 'middle' }}>
                        <RowActions
                          status={r.status}
                          onView={() => { setSelectedRequest(r); setShowViewModal(true); }}
                          onApprove={() => { setSelectedRequest(r); setShowApproveModal(true); }}
                          onDeny={() => { setSelectedRequest(r); setShowDenyModal(true); }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {!loadingRequests && currentTotal > 0 && (
              <InlinePagination
                page={currentPage}
                pageSize={PAGE_SIZE}
                total={currentTotal}
                onPageChange={(p) => handlePageChange(currentStatus, p)}
              />
            )}
          </div>
        </div>
      </div>

      {showViewModal && (
        <ViewRequestModal
          closeModal={() => setShowViewModal(false)}
          request={selectedRequest}
          handleApprove={() => setShowApproveModal(true)}
          handleDeny={() => setShowDenyModal(true)}
        />
      )}
      {showApproveModal && (
        <ApproveRequestModal
          closeModal={() => setShowApproveModal(false)}
          request={selectedRequest}
          getData={refreshCurrentTab}
        />
      )}
      {showDenyModal && (
        <DenyRequestModal
          closeModal={() => setShowDenyModal(false)}
          request={selectedRequest}
          getData={refreshCurrentTab}
        />
      )}
      {showRequestModal && (
        <RequestModal
          closeModal={() => {
            setShowRequestModal(false);
            refreshCurrentTab();
          }}
          teamMembers={teamMembers}
          isManagerInitiated
        />
      )}
    </>
  );
}

export default MembersPto;
